// Public config signal — values served by the backend at GET /api/v1/config/public
// so frontend marketing copy (T&C, plan-selection, event-signup) and admin
// tooltips don't have to hardcode demo length / reactivation length.
//
// Defaults mirror backend settings.py so the SPA renders correct numbers
// before the first network response arrives. The loader is fired from the
// app bootstrap (`core/app-preact.jsx`); subsequent reads are synchronous
// off the signal.

import { signal } from '@preact/signals'

export const publicConfig = signal({
  demo_duration_days: 21,
  demo_reactivation_days: 5,
  // DEMO daily cell-view ("deep dive") quota. Now served by /config/public from
  // the EFFECTIVE demo config (admin override included), so this literal is only a
  // pre-network notnagel. The live per-user counter still comes from the
  // X-Demo-Views-* headers / usage-summary, not this default.
  demo_cell_view_daily_limit: 10,
})

let _loadPromise = null

export function loadPublicConfig() {
  if (_loadPromise) return _loadPromise
  _loadPromise = fetch('/api/v1/config/public', {
    headers: { Accept: 'application/json' },
    credentials: 'omit',
  })
    .then((r) => {
      if (!r.ok) throw new Error(`config endpoint ${r.status}`)
      return r.json()
    })
    .then((data) => {
      publicConfig.value = {
        demo_duration_days: Number(data.demo_duration_days) || publicConfig.value.demo_duration_days,
        demo_reactivation_days: Number(data.demo_reactivation_days) || publicConfig.value.demo_reactivation_days,
        demo_cell_view_daily_limit:
          Number(data.demo_cell_view_daily_limit) || publicConfig.value.demo_cell_view_daily_limit,
      }
      return publicConfig.value
    })
    .catch((err) => {
      // Non-fatal: defaults stay in place. Log so a misconfigured prod is
      // visible in the console.
      console.warn('[publicConfig] falling back to defaults:', err)
      _loadPromise = null  // allow retry on next call
      return publicConfig.value
    })
  return _loadPromise
}
